///////////////////////////////////////////////////

import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { filter, ignoreElements, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export function clearTabContentEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { clearTabContent } = tabsApiConnector(httpClient, 'secondaryMarketPostEvents');

    return actions$.pipe(
      ofType('WORKSPACE_TAB_REMOVED'),
      filter(t => t.workspace === 'secondaryMarketPostEvents'),
      mergeMap(({ id }) => clearTabContent(id).pipe(ignoreElements())),
    );
  };
}
